import React, { Component } from "react";
import SearchPanel from "./SearchPanel";
import { withMobileDialog } from "@material-ui/core";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { store } from "../../_store";
import { commonActions, alertActions } from "../../_actions";
import { EmptyRecord } from "../../utils/PageUtility";
import WalletTable from "./WalletTable";
import CircularProgress from "../../utils/CircularProgress";

//icons
import DownloadIcon from "@material-ui/icons/CloudDownload";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";

import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
import { appHelpers } from "../../_helpers";

class WalletReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      AirlineId: "-1",
      AirportCode: "-1",
      requestingRecords: true,
      totalRecordCount: 0,
      walletRecords: null,
      pageSize: 10,
      currentPage: 1,
      airlines: [],
      airports: [],
      reorderOptions: [
        { value: "", name: "All re-order level" },
        { value: true, name: "Above min re-order level" },
        { value: false, name: "Below min re-order level" },
      ],
      reorder: "",
    };
  }

  componentDidMount() {
    let { airlines, airports, user } = store.getState();
    const { dispatch } = this.props;
    if (!airlines) {
      dispatch(commonActions.getAllAirlines());
    }
    if (!airports) {
      dispatch(commonActions.getAllAirports());
    }

    /*Check Type of User*/
    if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
      let userObj = { ...user };
      let userLocation = {
        value: userObj.AirportCode,
        label: userObj.Location,
      };
      this.setState({ AirportCode: userLocation }, this.handleSearch);
    } else if (user.AppRole === appConstants.ROLES.AIRLINE) {
      let userObj = { ...user };
      let userAirline = {
        value: userObj.AirlineId,
        label: userObj.AirlineName,
      };
      this.setState({ AirlineId: userAirline }, this.handleSearch);
    } else if (user.Location) {
      let userObj = { ...user };
      let userLocation = {
        value: userObj.AirportCode,
        label: userObj.Location,
      };
      this.setState({ AirportCode: userLocation }, this.handleSearch);
    } else {
      this.handleSearch();
    }
  }

  componentWillReceiveProps() {
    let { airlines, airports } = store.getState();
    if (airlines) {
      let modifiedAirline = [...airlines];
      let allAirlines = { Airline: "All Airlines", AirlineId: "-1" };
      modifiedAirline.unshift(allAirlines);
      this.setState({ airlines: modifiedAirline });
    }
    if (airports) {
      let modifiedAirport = [...airports];
      modifiedAirport.unshift({ Name: "All Airports", airportLocation: "-1" });
      this.setState({ airports: modifiedAirport });
    }
  }

  handleSelectChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  //   handleReactSelectChange = (value, name) => {
  //     this.setState({[name.name]: value.value})
  // };
  handleReactSelectChange = (value, name) => {
    this.setState({ [name.name]: value });
    if (
      value.value === undefined ||
      value.value === "-1" ||
      value.value === null
    ) {
      this.setState({ [name.name]: "-1" });
    }
  };

  handleSearch = (pageNumber = 1, payload) => {
    const { AirlineId, pageSize, AirportCode, reorder } = this.state;
    const { dispatch } = this.props;

    if (!payload) {
      payload = {
        From: pageNumber,
        Size: pageSize,
        AboveReorderLevel: reorder.value,
      };
      if (AirlineId !== "-1") {
        payload.AirlineId = AirlineId.value;
      }
      if (AirportCode !== "-1") {
        payload.AirportCode = AirportCode.value;
      }
    }
    dispatch(alertActions.startRequest());
    commonService.searchAirlineWalletReport(payload).then((res) => {
      dispatch(alertActions.stopRequest());
      let response = res.response;
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.setState({
          requestingRecords: false,
          currentPage: pageNumber,
          totalRecordCount: response.Entity.TotalCount,
          walletRecords: response.Entity.AirlineWallet,
        });
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        this.setState({ requestingPayments: false });
      }
    });
  };

  downloadAirlineWalletReport = (type, pageNumber = 1) => {
    const { AirlineId, AirportCode, reorder } = this.state;
    const { dispatch } = this.props;

    let payload = {
      From: pageNumber,
      Type: type,
      AboveReorderLevel: reorder.value,
    };
    if (AirlineId !== "-1") {
      payload.AirlineId = AirlineId.value;
    }
    if (AirportCode !== "-1") {
      payload.AirportCode = AirportCode.value;
    }
    dispatch(alertActions.startRequest());
    commonService.downloadAirlineWalletReport(payload).then((res) => {
      dispatch(alertActions.stopRequest());
      let response = res.response;
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        const isBase64 = response.base64File ? true : false;
        const fileData = response.base64File || response; // filestream is in response directly
        const mimeType = appHelpers.getMimeTypeFromType(payload.Type);
        appHelpers.downloadFileV3(
          fileData,
          "Airline Wallet Report",
          isBase64,
          mimeType
        );
        // appHelpers.downloadFile(response.DownloadUrl, "Transit Passenger Report");
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        this.setState({ pageRequesting: false });
      }
    });
  };
 

  render() {
    const {
      requestingRecords,
      walletRecords,
      totalRecordCount,
      pageSize,
      currentPage,
      AirlineId,
      AirportCode,
      airlines,
      airports,
      reorderOptions,
      reorder,
    } = this.state;
    const { classes, user, requesting } = this.props;

    if (requestingRecords) return <CircularProgress />;

    return (
      <div>
        <GridContainer>
          <SearchPanel
            user={user}
            airlines={airlines}
            airports={airports}
            AirlineId={
              this.props.user.AppRole === appConstants.ROLES.AIRLINE
                ? AirlineId
                : AirlineId.value
            }
            AirportCode={
              this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER ||
              user.Location
                ? AirportCode
                : AirportCode.value
            }
            selectChange={this.handleReactSelectChange}
            // selectChange={(e, name) => this.handleReactSelectChange(e, name)}
            onSearch={this.handleSearch}
            reorderOptions={reorderOptions}
            reorder={reorder.value}
          />
        </GridContainer>

        <GridContainer>
          {/* Table */}
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="success">
                <h4 className={classes.cardTitleWhite}>
                  Wallet Balance Report
                </h4>
                <p className={classes.cardCategoryWhite}>
                  Wallet Balance Records for Airlines
                </p>
              </CardHeader>
              <CardBody>
                {!requestingRecords && totalRecordCount !== 0 && (
                  <WalletTable
                    walletRecords={walletRecords}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    fetchWalletRecords={this.handleSearch}
                    totalRecordCount={totalRecordCount}
                  />
                )}

                {!requestingRecords && totalRecordCount === 0 && (
                  <EmptyRecord message={"No wallet record"} />
                )}
              </CardBody>
              {!requestingRecords && totalRecordCount !== 0 && (
                <CardFooter chart>
                  <div>
                    <Button
                      onClick={() =>
                        this.downloadAirlineWalletReport("pdf", currentPage)
                      }
                      type="button"
                      color="info"
                      disabled={requesting}
                    >
                      <DownloadIcon />
                      Download PDF
                    </Button>
                    <Button
                      onClick={() =>
                        this.downloadAirlineWalletReport("excel", currentPage)
                      }
                      type="button"
                      color="primary"
                      disabled={requesting}
                    >
                      <DownloadIcon />
                      Download EXCEL
                    </Button>
                  </div>
                </CardFooter>
              )}
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { airlines, airports, user, requesting } = state;
  return {
    airlines,
    airports,
    user,
    requesting,
  };
}

export default connect(mapStateToProps)(
  withMobileDialog()(withStyles(dashboardStyle)(WalletReport))
);



// WEBPACK FOOTER //
// ./src/views/WalletReport/index.js